(function() {
    'use strict';

    angular
        .module('app.reportes')
        .run(appRun);

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/general-planilla',
                config: {
                    templateUrl: 'app/reportes/generalPlanilla.html',
                    controller: 'GeneralPlanilla',
                    controllerAs: 'vm',
                    title: 'GeneralPlanilla'
                }
            },
            {
                url: '/previo-planilla',
                config: {
                    templateUrl: 'app/reportes/previoPlanilla.html',
                    controller: 'PrevioPlanilla',
                    controllerAs: 'vm',
                    title: 'PrevioPlanilla'
                }
            },
            {
                url: '/bancario-bncr',
                config: {
                    templateUrl: 'app/reportes/bancarioBNCR.html',
                    controller: 'BancarioBNCR',
                    controllerAs: 'vm',
                    title: 'BancarioBNCR'
                }
            },
            {
                url: '/libro-salarios',
                config: {
                    templateUrl: 'app/reportes/libroSalarios.html',
                    controller: 'LibroSalarios',
                    controllerAs: 'vm',
                    title: 'LibroSalarios'
                }
            },
            {
                url: '/archivo-asociacion-solidarista',
                config: {
                    templateUrl: 'app/reportes/archivoAsociacionSolidarista.html',
                    controller: 'ArchivoAsociacionSolidarista',
                    controllerAs: 'vm',
                    title: 'ArchivoAsociacionSolidarista'
                }
            },
            {
                url: '/historico-salarios',
                config: {
                    templateUrl: 'app/reportes/historicoSalarios.html',
                    controller: 'HistoricoSalarios',
                    controllerAs: 'vm',
                    title: 'HistoricoSalarios'
                }
            },
            {
                url: '/reporte-vacaciones',
                config: {
                    templateUrl: 'app/reportes/vacaciones.html',
                    controller: 'ReporteVacaciones',
                    controllerAs: 'vm',
                    title: 'ReporteVacaciones'
                }
            },
            {
                url: '/reporte-asientos',
                config: {
                    templateUrl: 'app/reportes/asientos.html',
                    controller: 'ReporteAsientos',
                    controllerAs: 'vm',
                    title: 'ReporteAsientos'
                }
            },
            {
                url: '/reporte-planilla-cc',
                config: {
                    templateUrl: 'app/reportes/planillaPorCC.html',
                    controller: 'ReportePlanillaPorCC',
                    controllerAs: 'vm',
                    title: 'ReportePlanillaPorCC'
                }
            }      
        ];
    }
})();
